<template>
  <div>
    <div>
      <ValidationObserver ref="loginForm" slim>
        <b-form @submit.prevent="send" class="clearfix mb-3">
          <ValidationProvider
              name="Agency name"
              :rules="{ required: true }"
              v-slot="vContext"
            >
            <b-form-group :label="$gettext('Agency name') + ':'" label-class="font-weight-bold pt-0 my-1" label-for="agency">
              <b-input
                type="text"
                name="agency"
                id="agency"
                v-model="register.agency"
                :placeholder="$gettext('Agency name')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="agency"
              />
              <b-form-invalid-feedback id="agency">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
              name="EIC"
              :rules="{ required: true }"
              v-slot="vContext"
            >
            <b-form-group :label="$gettext('EIC') + ':'" label-class="font-weight-bold pt-0 my-1" label-for="eic">
              <b-input
                type="text"
                name="EIC"
                id="eic"
                v-model="register.eic"
                :placeholder="$gettext('EIC')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="eic"
              />
              <b-form-invalid-feedback id="eic">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
              name="VAT"
              :rules="{ required: true }"
              v-slot="vContext"
            >
            <b-form-group :label="$gettext('VAT') + ':'" label-class="font-weight-bold pt-0 my-1" label-for="vat">
              <b-input
                type="text"
                name="vat"
                id="vat"
                v-model="register.vat"
                :placeholder="$gettext('VAT')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="vat"
              />
              <b-form-invalid-feedback id="vat">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
            name="License Number"
            :rules="{required: true}"
            v-slot="vContext"
          >
            <b-form-group :label="$gettext('License number') + ':'" label-class="font-weight-bold pt-0 my-1" label-for="license">
              <b-input
                type="text"
                name="license"
                id="license"
                v-model="register.license"
                :placeholder="$gettext('License Number')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="license"
              />
              <b-form-invalid-feedback id="license">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
            name="Tour Operator or Travel Agent"
            :rules="{required: true}"
            v-slot="vContext"
          >
            <b-form-group :label="$gettext('Tour Operator or Travel Agent') + ':'" label-class="font-weight-bold pt-0 my-1" label-for="totra">
              <b-input
                type="text"
                name="totra"
                id="totra"
                v-model="register.totra"
                :placeholder="$gettext('Tour Operator or Travel Agent')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="totra"
              />
              <b-form-invalid-feedback id="totra">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
            name="Email"
            :rules="{required: true}"
            v-slot="vContext"
          >
            <b-form-group :label="$gettext('Email') + ':'" label-class="font-weight-bold pt-0 my-1" label-for="email">
              <b-input
                type="email"
                name="email"
                id="email"
                v-model="register.email"
                :placeholder="$gettext('Email')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="email"
              />
              <b-form-invalid-feedback id="email">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
            name="Phone"
            :rules="{required: true}"
            v-slot="vContext"
          >
            <b-form-group :label="$gettext('Phone Number') + ':'" label-class="font-weight-bold pt-0 my-1" label-for="phone">
              <b-input
                type="text"
                name="phone"
                id="phone"
                v-model="register.phone"
                :placeholder="$gettext('Phone Number')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="phone"
              />
              <b-form-invalid-feedback id="phone">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
            name="Contact"
            :rules="{required: true}"
            v-slot="vContext"
          >
            <b-form-group :label="$gettext('Contact person') + ':'" label-class="font-weight-bold pt-0 my-1" label-for="name">
              <b-input
                type="text"
                name="name"
                id="name"
                v-model="register.name"
                :placeholder="$gettext('Contact person')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="name"
              />
              <b-form-invalid-feedback id="name">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
            name="address"
            :rules="{required: true}"
            v-slot="vContext"
          >
            <b-form-group :label="$gettext('Company address') + ':'" label-class="font-weight-bold pt-0 my-1" label-for="address">
              <b-input
                type="text"
                name="address"
                id="address"
                v-model="register.address"
                :placeholder="$gettext('Company address')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="address"
              />
              <b-form-invalid-feedback id="address">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <hr>
          <div class="d-flex justify-content-between align-items-center">
            <p class="text-center py-1">
              <translate>For login</translate>&nbsp;
              <router-link :to="{ name: 'Public/Login' }" class="link"><translate> click here</translate></router-link>
            </p>
            <b-button type="submit" variant="primary" class="float-right" size="sm">
              <translate>Send</translate>
            </b-button>
          </div>
        </b-form>
      </ValidationObserver>
    </div>
    <b-modal id="success" hide-header hide-footer v-model="modalSuccess" centered>
      <template v-if="subscribeSuccess">
        <div class="d-flex align-item-center justify-content-center send-success">
          <div class="pt-4">
            <p class="d-flex align-item-center justify-content-center">
              <b-iconstack font-scale="5" animation="throb">
                <b-icon stacked icon="check2" variant="success" scale="0.75"></b-icon>
                <b-icon stacked icon="circle" variant="success"></b-icon>
              </b-iconstack>
            </p>
            <h4 class="text-center"><translate>The data was sent successfully!</translate></h4>
          </div>
        </div>
        <!-- <hr> -->
        <p class="my-4 text-center">
          <router-link :to="{ name: 'Public/Login' }" class="btn btn-warning">
            <b v-translate>Log in</b>
          </router-link>
        </p>
      </template>
      <template v-else>
        <div class="d-flex align-item-center justify-content-center send-fail">
          <div class="pt-4">
            <p class="d-flex align-item-center justify-content-center">
              <b-icon icon="slash-circle" animation="throb" font-scale="8" class="text-danger"></b-icon>
            </p>
            <h5 class="text-center"><translate>We apologize, there was an error in transmitting the data.</translate><br/><translate>Please, try again!</translate></h5>
          </div>
        </div>
        <hr>
        <p class="my-4 text-center">
          <b-button @click="closeModal" variant="primary" size="sm"> <b v-translate>Close</b> </b-button>
        </p>
      </template>
    </b-modal>
  </div>
</template>

<script>
import validation from 'b2b-common/mixins/validation'
import { register } from 'b2b-common/services/public'
import toast from 'b2b-common/mixins/toast'

export default {
  name: 'Subscribe',
  mixins: [validation, toast],
  data () {
    return {
      register: {
        agency: '',
        eic: '',
        vat: '',
        license: '',
        totra: '',
        email: '',
        phone: '',
        name: '',
        address: ''
      },
      modalSuccess: false,
      subscribeSuccess: true,
      country: [this.$gettext('Romania'), this.$gettext('Other')]
    }
  },
  methods: {
    send () {
      this.$refs.loginForm.validate().then(success => {
        if (!success) {
          this.addToast({
            title: this.$gettext('Invalid form'),
            message: this.$gettext('Please fill in all required fields!'),
            variant: 'danger'
          })
        } else {
          register(this.register).then(res => {
            if (res !== 'OK') this.subscribeSuccess = false
            this.modalSuccess = true
          })
        }
      })
    },
    closeModal () {
      this.modalSuccess = false
    }
  }
}
</script>
<style scoped>
  .send-success{
    border: 2px solid rgba(0,128,0,.5);
    border-radius:5px;
    background-color: rgba(226,249,224,.35);
  }
  .send-fail{
    border: 2px solid rgba(185,0,0,.5);
    border-radius:5px;
    background-color: rgba(230,196,1964,.35);
    padding: 0 1rem 1rem;
  }
</style>
